import script from "./ListarRecessos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarRecessos.vue?vue&type=script&setup=true&lang=js"

import "./ListarRecessos.vue?vue&type=style&index=0&id=027236fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027236fc"]])

export default __exports__